












import { defineComponent } from '@nuxtjs/composition-api'
import { useI18n } from '~/composables/i18n'
import IconFaFileExcel from '~icons/fa-solid/file-excel'

export default defineComponent({
  components: {
    IconFaFileExcel,
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
})
